import React from 'react';
import Qr from './QrComponents/ReactQr'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Qr/>
    </div>
  );
}

export default App;
